export const SELECT_NOTE_URL = "SELECT_NOTE_URL";
export const selectNoteUrl = (ordersState) => {
    return {
        type: "SELECT_NOTE_URL",
        payload: {
            noteUrl: ordersState.noteUrl,
            identification: ordersState.identification,
            copyright: ordersState.copyright,
        }
    }
}


export const INPUT_BOOK_INFO = "INPUT_BOOK_INFO";
export const inputBookInfo = (ordersState) => {
    return {
        type: "INPUT_BOOK_INFO",
        payload: {
            bookTitle: ordersState.bookTitle,
            author: ordersState.author,
        }
    }
}

export const SELECT_BOOK_COVER = "SELECT_BOOK_COVER";
export const selectBookCover = (ordersState) => {
    return {
        type: "SELECT_BOOK_COVER",
        payload: {
            bookCover: ordersState.bookCover,
        }
    }
}

export const INPUT_PURCHASER_INFO = "INPUT_PURCHASER_INFO";
export const inputPurchaserInfo = (ordersState) => {
    return {
        type: "INPUT_PURCHASER_INFO",
        payload: {
            purchaser: ordersState.purchaser,
            furigana: ordersState.furigana,
            email: ordersState.email,
            birthOfDay: ordersState.birthOfDay,
            sex: ordersState.sex,
            howDidChermoKnow: ordersState.howDidChermoKnow,
            otherSpecificContent: ordersState.otherSpecificContent,
        }
    }
}